<template>
  <div>
    <v-dialog scrollable max-width="1200px" v-model="model" persistent>
      <material-card
        :title="
          $t(
            'components.plan_benefit_rules.view_plan_benefit_rules_configuration_dialog.view_benefit_rules_configuration_{0}',
            [planName]
          )
        "
        :color="$vuetify.theme.themes.light.secondary"
        icon="checklist"
      >
        <template v-slot:actions>
          <div style="margin-right:20px;margin-top: 10px;">
            <v-btn
              color="primary"
              @click="exportRules"
              :loading="downloading"
              :disabled="
                selected.memberGroup === null ||
                  selected.memberGroup === undefined ||
                  selected.effectiveDate === null ||
                  selected.effectiveDate === undefined
              "
            >
              {{ $t("globals.export") }}
            </v-btn>
          </div>
        </template>
        <v-card-text>
          <v-form v-model="valid">
            <v-container>
              <v-row>
                <div class="col-12 col-xs-12 col-sm-6">
                  <pbas-date-picker
                    class="required"
                    :value="selected.effectiveDate"
                    @update-date="effectiveDate = $event"
                    :label="$t('components.inmemorydependants.effective_date')"
                    :rules="[$rules.required]"
                  ></pbas-date-picker>
                </div>
                <div class="col-12 col-xs-12 col-sm-6">
                  <trans-select2
                    v-model="selected"
                    propertyName="memberGroup"
                    :items="memberGroups"
                    :label="
                      $t(
                        'globals.member_group'
                      )
                    "
                    field="Name"
                    itemValue="IdentityId"
                    :rules="[$rules.required]"
                    class="required"
                  ></trans-select2>
                </div>
              </v-row>
              <!-- </v-card-text> -->
              <v-divider />
              <!-- <v-card-text> -->
              <span class="minfo">
                {{
                  $t(
                    "components.plan_benefit_rules.view_plan_benefit_rules_configuration_dialog.plan_benefits_per_category"
                  )
                }}
              </span>
              <v-row>
                <div
                  class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3"
                  v-for="category in benefitCategories"
                  :key="category.Category"
                >
                  <benefit-category-tile
                    :category="category"
                    :planName="planName"
                    :effectiveDate="effectiveDate"
                    :planIdentityId="planConfiguration.PlanId"
                    @expand="closeRest(category.Category)"
                    :expanded="expandedCategories[category.Category]"
                    :memberGroupIdentityId="selected.memberGroup.IdentityId"
                  />
                </div>
              </v-row>
              <!-- </v-card-text> -->
              <v-divider />
              <!-- <v-card-title>
              {{$t("views.guides.health_reasonable_&_customary_guides")}}
            </v-card-title> -->
              <!-- <v-card-text> -->
              <span class="minfo">
                {{
                  $t(
                    "components.plan_benefit_rules.view_plan_benefit_rules_configuration_dialog.health_reasonable_&_customary_guides_fee_guides"
                  )
                }}
              </span>
              <v-row>
                <div
                  class="col-12 col-xs-12 col-sm-6 col-md-4 col-lg-3"
                  v-for="guide in planFeeGuides"
                  :key="guide.Id"
                >
                  <!-- <plan-guide-tile :guide="guide.FeeGuide" /> -->
                  {{
                    `${guide.FeeGuide.Name} - ${getProvinceName(
                      guide.FeeGuide.ProvinceId
                    )} - ${guide.FeeGuide.Year}`
                  }}
                </div>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            @click="
              $emit('close');
              item = null;
            "
          >
            {{ $t("globals.close") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog v-model="loading" scrollable max-width="100px" persistent>
      <v-container fluid grid-list-md>
        <v-layout v-if="loading" row justify-center>
          <v-flex xs12 sm6 md4 lg3>
            <v-progress-circular indeterminate></v-progress-circular>
          </v-flex>
        </v-layout>
      </v-container>
    </v-dialog>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import ErrorHandler from "@/components/ErrorHandler.vue";
import { mapActions, mapGetters } from "vuex";
import BenefitCategoryTile from "@/components/PlanBenefitsRules/BenefitCategoryTile";
// import PlanGuideTile from "@/components/PlanBenefitsRules/PlanGuideTile";
import TransSelect2 from "../TransSelect2.vue";
import { translate } from "@/trans";
export default {
  props: ["model", "planConfiguration", "planName"],
  components: {
    ErrorHandler,
    BenefitCategoryTile,
    TransSelect2,
    // PlanGuideTile,
  },
  data() {
    return {
      error: null,
      benefitCategories: [],
      planFeeGuides: [],
      valid: false,
      loading: false,
      downloading: false,
      expandedCategories: {},
      selected: {
        memberGroup: null,
        effectiveDate: null,
      },
      memberGroups: [],
    };
  },
  computed: {
    ...mapGetters("plansMembers", ["options"]),
    ...mapGetters("common", ["language"]),
  },
  watch: {
    model: {
      handler(v) {
        if (v) {
          console.log("view dialog: ", this.planConfiguration);
          this.$nextTick(async () => {
            this.selected.effectiveDate = this.planConfiguration.EffectiveDate;
            await this.loadMemberGroups();
          });
        }
      },
    },
    "selected.effectiveDate": {
      handler(v) {
        if (v) {
          console.log("view dialog effective date: ", v);
          this.loadData();
        }
      },
    },
    "selected.memberGroup": {
      handler(v) {
        if (v) {
          console.log("view dialog member group: ", v);
          this.loadData();
        }
      },
    },
  },
  methods: {
    ...mapActions("claims", ["getPlanBenefitCategories", "getPlanFeeGuides"]),
    ...mapActions("plansMembers", ["getBlobAsync", "getMemberGroups"]),
    async loadMemberGroups() {
      this.loading = true;
      try {
        this.memberGroups = (await this.getMemberGroups({
          plan: this.planConfiguration.PlanId,
          url: "?$expand=Translations",
        })).data.value;
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    async loadData() {
      if (this.selected.effectiveDate === null || this.selected.effectiveDate === undefined) {
        return;
      }
      if (this.selected.memberGroup === null || this.selected.memberGroup === undefined) {
        return;
      }
      this.loading = true;
      try {
        this.benefitCategories = (await this.getPlanBenefitCategories({
          memberGroupIdentityId: this.selected.memberGroup.IdentityId,
          effectiveDate: this.selected.effectiveDate,
        })).data;
        this.planFeeGuides = (await this.getPlanFeeGuides({
          planIdentityId: this.planConfiguration.PlanId,
          effectiveDate: this.selected.effectiveDate,
        })).data.value;
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    getProvinceName(id) {
      return translate(
        this.options.Models.Province.filter((o) => o.Id === id)[0],
        this.language.language
      );
    },
    async exportRules() {
      this.downloading = true;
      const [date, time] = this.planConfiguration.EffectiveDate.split("T");
      const [year, month, day] = date.split("-");
      const dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
      const url = `member-groups/${
        this.selected.memberGroup.IdentityId
      }/effective-date/${dateFormatted}/plan-benefits/export`;

      const filename = `${this.planName}_${year}-${month}-${day}_Template.xlsx`;
      try {
        let blob = (await this.getBlobAsync({ url: url })).data;

        const url2 = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url2;
        link.setAttribute("download", filename); //or any other extension
        link.setAttribute("id", "link1"); //or any other extension
        document.body.appendChild(link);
        link.click();
        var element = document.getElementById("link1");
        element.parentNode.removeChild(element);
      } catch (error) {
        this.error = error;
      }
      this.downloading = false;
    },
    closeRest(category) {
      console.log(category, this.benefitCategories.map((o) => o.Category));
      for (let cat of this.benefitCategories) {
        if (category === cat.Category) {
          this.expandedCategories[cat.Category] = true;
        } else {
          this.expandedCategories[cat.Category] = false;
        }
      }
      console.log(this.expandedCategories);
      this.$forceUpdate();
    },
  },
};
</script>
<style scoped>
.minfo {
  font-weight: bold;
  color: #222;
}
</style>
<style></style>
